<div class="inatividade-canal">
  <div class="topico-modal-lateral topico-modal-lateral--full" style="position: relative; top: -10px;">
    <span class="label">Mensagem de inatividade</span>
  </div>

  <div class="inatividade-canal__conteudo">
    <div class="inatividade-canal__toggle">
      <span class="label">Inatividade da Sessão?</span>
      <app-slide-toggle-padrao
        [valor]="inatividadeAtiva"
        [disabled]="readOnly"
        labelTrue="Sim"
        labelFalse="Não"
        (changeValue)="alternarInatividade($event)">
      </app-slide-toggle-padrao>
    </div>

    @if (inatividadeAtiva) {
      @if (!readOnly && podeAdicionarPeriodo) {
        <app-button-padrao
          width="fit-content"
          height="20px"
          [fontSize]="'12px'"
          [padding]="'2px 10px'"
          [label]="textoBotaoAcao"
          backgroundColor="var(--primary)"
          color="white"
          (buttonClick)="adicionarPeriodo()"></app-button-padrao>
      }

      @if (deveMostrarEditor) {
        <div class="inatividade-canal__editor">
          <div class="inatividade-canal__campos_1">
            <app-form-field
              widthFormField="100%"
              heightFormField="35px"
              type="time"
              [value]="periodoForm.tempoInatividade"
              placeholder="00:00"
              [disabled]="readOnly"
              label="Tempo de Inatividade"
              (changeValue)="periodoForm.tempoInatividade = $event">
            </app-form-field>

            <div class="inatividade-canal__toggle">
              <span class="label">Tipo</span>
              <app-slide-toggle-padrao
                [valor]="tipoAcaoSelecionado"
                [disabled]="readOnly"
                labelTrue="Fluxo"
                labelFalse="Mensagem"
                (changeValue)="alternarTipoAcao($event)">
              </app-slide-toggle-padrao>
            </div>
          </div>

          @if (periodoForm.tipoAcao === tipoAcaoMensagem) {
            <span class="label">Mensagem de Inatividade de Funcionamento</span>
            <textarea
              style="font-size: 12px"
              [value]="periodoForm.mensagem"
              (input)="periodoForm.mensagem = $any($event.target).value"
              rows="4"
              [disabled]="readOnly"
            ></textarea>
          }

          @if (periodoForm.tipoAcao === tipoAcaoFluxo) {
            <div class="inatividade-canal__campos">
              <app-select-one
                widthFormField="100%"
                heightFormField="35px"
                [listaInput]="fluxos"
                [itemSelecionado]="periodoForm.fluxo"
                campo="nome"
                label="Fluxo"
                placeholder="Selecione"
                [carregandoInfo]="carregandoFluxos"
                [disabled]="readOnly"
                (selecionarItem)="selecionarFluxo($event)">
              </app-select-one>

              <app-select-one
                widthFormField="100%"
                heightFormField="35px"
                [listaInput]="etapas"
                [itemSelecionado]="periodoForm.etapa"
                campo="titulo"
                label="Etapa"
                placeholder="Opcional"
                [carregandoInfo]="carregandoEtapas"
                [disabled]="readOnly || !periodoForm.fluxo?.id"
                (selecionarItem)="selecionarEtapa($event)">
              </app-select-one>
            </div>
          }

          <div class="inatividade-canal__acoes">
            <app-button-padrao
              width="36px"
              height="36px"
              backgroundColor="var(--verde-padrao)"
              color="white"
              icon="check"
              (buttonClick)="salvarPeriodo()"></app-button-padrao>

            <app-button-padrao
              width="36px"
              height="36px"
              backgroundColor="white"
              color="var(--vermelho-padrao)"
              borderColor="var(--vermelho-padrao)"
              borderStyle="solid"
              borderWidth="1px"
              icon="close"
              (buttonClick)="cancelarEdicao()"></app-button-padrao>
          </div>
        </div>
      }
    }

    @if (deveMostrarLista) {
      <div class="inatividade-canal__lista">
        @for (periodo of periodos; track trackByPeriodo($index, periodo)) {
          <div class="periodo-card">
            <div class="periodo-card__principal">
              <div class="periodo-card__cabecalho">
                <span class="periodo-card__tempo">{{ periodo.tempoInatividade }}</span>
                <span class="periodo-card__tipo">{{ formatarTipo(periodo) }}</span>
              </div>

              <span class="periodo-card__conteudo">{{ obterConteudoPeriodo(periodo) }}</span>
              @if (obterEtapaPeriodo(periodo)) {
                <span class="periodo-card__etapa">{{ obterEtapaPeriodo(periodo) }}</span>
              }
            </div>

            @if (!readOnly) {
              <div class="periodo-card__acoes">
                <img
                  width="22px"
                  height="22px"
                  class="icones cursor-pointer"
                  src="./assets/icones/edit.svg"
                  alt="Editar período"
                  tabindex="0"
                  role="button"
                  (click)="editarPeriodo($index)"
                  (keydown.enter)="editarPeriodo($index)" />
                <img
                  width="22px"
                  height="22px"
                  class="icones cursor-pointer"
                  src="./assets/icones/delete-forever.svg"
                  alt="Remover período"
                  tabindex="0"
                  role="button"
                  (click)="removerPeriodo($index)"
                  (keydown.enter)="removerPeriodo($index)" />
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
